import { I18n } from "@assets/strings";
import React from "react";
import { useHistory } from "@core/routing/useHistory";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { useServices } from "@core/servicesContext";
import { Group } from "@domain/group/group";
import { ClosableModal } from "@ui/modals/closableModal";
import { gap, mobile } from "@ui/styles/utils";
import { PrimaryButton } from "@ui/components/buttons/primaryButton";
import { Smalldescription } from "@ui/components/containers/description";
import { Subtitle } from "@ui/components/containers/title";
import { SuccessIcon } from "@ui/components/icons";
import { stack } from "@ui/components/layout";

interface ShareroomMonetisationFinishModalProps extends React.HTMLAttributes<HTMLDivElement> {
	close: () => void;
	shareroom: Group;
}

export const ShareroomMonetisationFinishModal: React.FC<ShareroomMonetisationFinishModalProps> = ({
	close,
	shareroom,
	...htmlProps
}) => {
	const history = useHistory();
	const { trackingService } = useServices();
	return (
		<Container close={close} {...htmlProps}>
			<SuccessIcon />
			<Subtitle>{I18n.t("shareroom.dashboard.settings.success.title")}</Subtitle>
			<Descriptions>{I18n.t("shareroom.dashboard.settings.success.description")}</Descriptions>
			<Actions>
				<PrimaryButton
					onClick={() => {
						trackingService.track("Monetize my classroom_flow DONE");
						history.push(Path.Shareroom(shareroom, "dashboard"));
						close();
					}}
				>
					{I18n.t("shareroom.dashboard.settings.sucess.button.label")}
				</PrimaryButton>
			</Actions>
		</Container>
	);
};

const Container = styled(ClosableModal)`
	width: 100%;
	${stack(30)};
	align-items: center;
	text-justify: center;
	align-content: justify;
	padding: 50px 40px;
`;
const Actions = styled.div`
	display: flex;
	flex: 1;
	align-items: center;
	flex-direction: column;
	${gap(25)};

	@media ${mobile} {
		${gap(15)};
		> button {
			padding: 12px 20px;
		}
	}
`;

const Descriptions = styled(Smalldescription)`
	padding: 20px 20px;
`;
